// @flow
import type { Reducer } from 'redux';
import { createReducer } from 'redux-act';

import type { TLDs, TLDs as State } from '../../types';
import { set } from '../actions/tlds';

const initialState: State = [];

const setHandler = (state: State, tlds: TLDs): State => tlds;

export default (createReducer(
  {
    [set.getType()]: setHandler,
  },
  initialState,
): Reducer<State, mixed>);
